import { render, staticRenderFns } from "./resumeBaseInfo.vue?vue&type=template&id=4ed7eaa2&scoped=true"
import script from "./resumeBaseInfo.vue?vue&type=script&lang=js"
export * from "./resumeBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./resumeBaseInfo.vue?vue&type=style&index=0&id=4ed7eaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7eaa2",
  null
  
)

export default component.exports